import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";

export default class LendingBankSettings extends BaseProductSettings {
    enabled: boolean = false;
    overridable: boolean = false;
    fasterPaymentsInboundEnabled: boolean = true;
    fasterPaymentsOutboundEnabled: boolean = true;
    chapsInboundEnabled: boolean = true;
    chapsOutboundEnabled: boolean = true;
    directDebitsEnabled: boolean = true;
    directCreditsEnabled: boolean = true;
    bacsInboundEnabled: boolean = true;
    bacsOutboundEnabled: boolean = true;
}